import classnames from 'classnames'
import type {ReactNode, SyntheticEvent} from 'react'
import {memo, useCallback} from 'react'

import type {BuildId} from '../../../../types'
import {BS} from '../../../../types/BS_types'
import {noop} from '../../../../utils/empty'
import PopupControl from '../../../classic/PopupControl/PopupControl'

import styles from './ChangesDropdown.css'

const BSPopup = BS?.ChangesPopup
const hidePopupCommand = BSPopup ? () => BSPopup.hidePopup() : noop
const stopHidingPopupCommand = BSPopup ? () => BSPopup.stopHidingPopup() : noop

type Props = {
  className?: string
  buildId: BuildId
  label: ReactNode
  noPopup?: boolean
  highlightChanges?: boolean
  controlId?: string
  wrapperProps?: React.HTMLAttributes<HTMLElement>
  isQueued: boolean
}

const Popup = BS?.ChangesPopup

function ChangesDropdown({
  className,
  buildId,
  label,
  noPopup,
  highlightChanges,
  controlId,
  wrapperProps,
  isQueued,
}: Props) {
  const showPopupCommand = useCallback(
    (e: Event | SyntheticEvent<HTMLSpanElement>) =>
      Popup &&
      e.currentTarget instanceof HTMLElement &&
      Popup.showBuildChangesPopup(e.currentTarget, buildId, !isQueued),
    [buildId, isQueued],
  )

  const props = {
    className: classnames(styles.wrapper, className, {highlightChanges}),
    children: label,
    'data-test': 'changes',
  }

  if (label == null) {
    return null
  }

  if (noPopup) {
    return <span {...props} />
  }

  return (
    <PopupControl
      {...props}
      wrapperProps={wrapperProps}
      showPopupCommand={showPopupCommand}
      hidePopupCommand={hidePopupCommand}
      stopHidingPopupCommand={stopHidingPopupCommand}
      controlId={controlId}
    />
  )
}

export default memo<Props>(ChangesDropdown)
